<template>
	<div class="contact-wrapper" :style="{ paddingBottom: (safeAreaInsetBottom || 15) + 'px' }">
		<div class="row" @click.stop="gotoIMchat">
			联系牛小二
		</div>

		<div class="row" v-if="showPhone" @click.stop="makeCall">
			客服电话
		</div>

		<!--		<div class="row" v-if="isCNDO" @click.stop="enterLg">-->
		<!--			新版二手车-->
		<!--		</div>-->

		<div class="row">
			<nio-button style="width: 100%" type="btn_outline_l" @click="$emit('close')">取消</nio-button>
		</div>
	</div>
</template>

<script>
import util from '@/util/util'
import hybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import qs from 'qs'

export default {
	name: 'ContactPopup',
	props: {
		showPhone: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			isCNDO: hybrid.isCNDo(),
			safeAreaInsetBottom: getSafeInsetBottom()
		}
	},
	methods: {
		gotoIMchat() {
			this.$emit('select', '联系牛小二');
			if (util.isInWebview()) {
				if (!util.isToken()) {
					hybrid.openLoginPage(() => {
						this.openIMchat()
					})
					return
				} else {
					this.openIMchat()
				}
			}
		},

		makeCall() {
			this.$emit('select', '客服电话');
			hybrid.makeCall('4009996699')
		},

		enterLg() {
			const url =
				util.getBaseEnvInfo().openUrl +
				`/module_10021/carhome?${qs.stringify({
					wv: 'lg',
					is_nav_show: false
				})}`
			hybrid.openURL(url)
		},

		openIMchat() {
			hybrid.openURL(
				`nio://conversation?id=${util.getBaseEnvInfo().secondHandChatPersonId}&type=private`
			)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.contact-wrapper {
	background-color: #ffffff;
	padding-left: 20px;
	padding-right: 20px;

	.row {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;

		&.large {
			height: 75px;
		}
		&:not(:last-child) {
			@include subtitle_3();
			color: $text_primary;
		}
	}
}
</style>
